import React from 'react';
import {
    Box,
    Container,
    Grid,
    Typography,
    Link,
    IconButton,
    Divider,
    Button,
    TextField,
    InputAdornment
} from '@mui/material';
import {
    Facebook,
    Twitter,
    LinkedIn,
    YouTube,
    Instagram,
    Email,
    Phone,
    LocationOn,
    Send,
    ShoppingBag,
    Info,
    ContactMail,
    Store,
    CalculateRounded
} from '@mui/icons-material';
import SvgIcon from '@mui/material/SvgIcon';
import { ThemeProvider } from '@mui/material/styles';
import createAppTheme from '../theme/theme'; // Import the theme from your main theme file
import logo from '../images/colored_logo.PNG'; // Import the logo
import { Storefront } from '@mui/icons-material'; // Add this to your imports

function Tiktok(props) {
    return (
        <SvgIcon {...props}>
            <path d="M12.5 2c1.5 0 2.9.6 3.9 1.6.4.4.7.8 1 1.2v.2c.4.5 1 .8 1.6.9h.2v3.1c-1.3-.1-2.6-.6-3.7-1.3V14c0 3.3-2.7 6-6 6s-6-2.7-6-6c0-3 2.2-5.5 5.1-5.9V11c-.6.3-1 .9-1 1.6 0 1 .8 1.9 1.9 1.9s1.9-.8 1.9-1.9V2h1.1z" />
        </SvgIcon>
    );
}

const AppFooter = ({ language = 'en', t = {} }) => {
    const isArabic = language === 'ar';
    const theme = createAppTheme(true, language === 'ar');

    // Get translations from props, fallback to default if not provided
    const translations = t;

    const quickLinks = [
        { label: translations.home, icon: <Store />, href: '/' },
        { label: translations.store, icon: <ShoppingBag />, href: '/store' },
        // { label: translations.priceCalculator, icon: <CalculateRounded />, href: '/calculator' },
        { label: translations.about, icon: <Info />, href: '/about' },
        { label: translations.contact, icon: <ContactMail />, href: '/contact' }
    ];

    const services = [
        translations.customJewelry,
        translations.goldBuying,
        translations.appraisal,
        translations.repair
    ];

    const socialLinks = [
        { icon: <Instagram />, href: 'https://instagram.com/Al Naabi Jewellery company.kw', label: translations.instagramLabel },
        { icon: <Tiktok />, href: 'https://www.tiktok.com/@Al Naabi Jewellery company.kw', label: translations.tiktokLabel }
    ];

    const handleSubscribe = (e) => {
        e.preventDefault();
        // Handle newsletter subscription
        console.log('Newsletter subscription');
    };

    return (
        <ThemeProvider theme={theme}>
            <Box
                component="footer"
                sx={{
                    background: 'linear-gradient(180deg, rgba(25, 39, 19, 0.97) 0%, rgba(14, 26, 9, 1) 100%)',
                    borderTop: '1px solid rgba(163, 242, 47, 0.18)',
                    mt: 'auto',
                    pt: { xs: 3, md: 6 },
                    pb: { xs: 2, md: 3 }
                }}
            >
                <Container maxWidth="xl">
                    <Grid container spacing={{ xs: 3, md: 4 }}>
                        {/* Brand Section */}
                        <Grid item xs={12} md={3}>
                            <Box
                                sx={{
                                    mb: { xs: 1.5, md: 2 },
                                    textAlign: { xs: 'center', md: 'left' }
                                }}
                            >
                                <img
                                    src={logo}
                                    alt={translations.title || 'Al Naabi Jewellery company Logo'}
                                    style={{
                                        height: 'auto',
                                        width: '100%',
                                        maxWidth: '100px',
                                        objectFit: 'contain'
                                    }}
                                />
                            </Box>
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                    mb: { xs: 2, md: 3 },
                                    lineHeight: 1.8,
                                    textAlign: { xs: 'center', md: 'left' },
                                    fontSize: { xs: '0.875rem', md: '0.875rem' }
                                }}
                            >
                                شركة مجوهرات النابي - {translations.brandDescription}
                            </Typography>

                            {/* Social Media Icons */}
                            {/* <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        mb: { xs: 1.5, md: 2 },
                                        color: 'primary.main',
                                        fontSize: { xs: '1.1rem', md: '1.25rem' }
                                    }}
                                >
                                    {translations.followUs}
                                </Typography>
                                <Box display="flex" gap={1} justifyContent={{ xs: 'center', md: 'flex-start' }}>
                                    {socialLinks.map((social, index) => (
                                        <IconButton
                                            key={index}
                                            href={social.href}
                                            sx={{
                                                color: 'text.secondary',
                                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                                borderRadius: '8px',
                                                width: { xs: 40, md: 48 },
                                                height: { xs: 40, md: 48 },
                                                '&:hover': {
                                                    color: 'primary.main',
                                                    borderColor: 'primary.main',
                                                    backgroundColor: 'rgba(212, 175, 55, 0.1)'
                                                }
                                            }}
                                        >
                                            {social.icon}
                                        </IconButton>
                                    ))}
                                </Box>
                            </Box> */}
                        </Grid>

                        {/* Quick Links */}
                        {/* <Grid item xs={12} sm={6} md={2}>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 2, md: 3 },
                                    color: 'primary.main',
                                    textAlign: { xs: 'center', sm: 'left' },
                                    fontSize: { xs: '1.1rem', md: '1.25rem' }
                                }}
                            >
                                {translations.quickLinks}
                            </Typography>
                            <Box
                                display="flex"
                                flexDirection="column"
                                gap={1.5}
                                alignItems={{ xs: 'center', sm: 'flex-start' }}
                            >
                                {quickLinks.map((link, index) => (
                                    <Link
                                        key={index}
                                        href={link.href}
                                        sx={{
                                            color: 'text.secondary',
                                            textDecoration: 'none',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            fontSize: { xs: '0.875rem', md: '1rem' },
                                            '&:hover': {
                                                color: 'primary.main',
                                                transform: 'translateX(4px)'
                                            },
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        <Box sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>{link.icon}</Box>
                                        {link.label}
                                    </Link>
                                ))}
                            </Box>
                        </Grid> */}

                        {/* Contact Info */}
                        {/* <Grid item xs={12} sm={6} md={2}>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 2, md: 3 },
                                    color: 'primary.main',
                                    textAlign: { xs: 'center', sm: 'left' },
                                    fontSize: { xs: '1.1rem', md: '1.25rem' }
                                }}
                            >
                                {translations.contactInfo}
                            </Typography>
                            <Box
                                display="flex"
                                flexDirection="column"
                                gap={2}
                                alignItems={{ xs: 'center', sm: 'flex-start' }}
                            >
                                <Box
                                    display="flex"
                                    alignItems="flex-start"
                                    gap={1}
                                    flexDirection={{ xs: 'column', sm: 'row' }}
                                    textAlign={{ xs: 'center', sm: 'left' }}
                                >
                                    <LocationOn sx={{
                                        color: 'primary.main',
                                        fontSize: { xs: '1.1rem', md: '1.2rem' },
                                        mt: 0.2,
                                        alignSelf: { xs: 'center', sm: 'flex-start' }
                                    }} />
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{
                                            lineHeight: 1.6,
                                            fontSize: { xs: '0.825rem', md: '0.875rem' }
                                        }}
                                    >
                                        {translations.address}
                                    </Typography>
                                </Box>
                                <Box
    display="flex"
    alignItems="center"
    gap={1}
    flexDirection={{ xs: 'column', sm: 'row' }}
>
    <Link
        href="https://maps.app.goo.gl/K7PReypFMX7kgi849?g_st=ipc"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            textDecoration: 'none',
            color: 'text.secondary',
            '&:hover': {
                color: 'primary.main',
                textDecoration: 'underline'
            }
        }}
    >
        <Storefront sx={{
            color: 'primary.main',
            fontSize: { xs: '1.1rem', md: '1.2rem' }
        }} />
        <Typography
            variant="body2"
            sx={{
                fontSize: { xs: '0.825rem', md: '0.875rem' }
            }}
        >
            {translations.storeLocation}
        </Typography>
    </Link>
</Box>
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                    flexDirection={{ xs: 'column', sm: 'row' }}
                                >
                                    <Phone sx={{
                                        color: 'primary.main',
                                        fontSize: { xs: '1.1rem', md: '1.2rem' }
                                    }} />
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{
                                            fontSize: { xs: '0.825rem', md: '0.875rem' }
                                        }}
                                    >
                                        {translations.phone}
                                    </Typography>
                                </Box>
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                    flexDirection={{ xs: 'column', sm: 'row' }}
                                >
                                    <Email sx={{
                                        color: 'primary.main',
                                        fontSize: { xs: '1.1rem', md: '1.2rem' }
                                    }} />
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{
                                            fontSize: { xs: '0.825rem', md: '0.875rem' }
                                        }}
                                    >
                                        {translations.email}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid> */}
                    </Grid>

                    <Divider sx={{ my: { xs: 3, md: 4 }, borderColor: 'rgba(163, 242, 47, 0.12)' }} />

                    {/* Bottom Section */}
                    <Box
                        display="flex"
                        flexDirection={{ xs: 'column', sm: 'row' }}
                        justifyContent="space-between"
                        alignItems="center"
                        gap={{ xs: 2, sm: 2 }}
                        textAlign={{ xs: 'center', sm: 'left' }}
                    >
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                                fontSize: { xs: '0.8rem', md: '0.875rem' },
                                order: { xs: 2, sm: 1 }
                            }}
                        >
                            © 2025 {translations.title}. {translations.allRightsReserved}
                        </Typography>
                        {/* <Box
                            display="flex"
                            gap={{ xs: 2, sm: 3 }}
                            flexWrap="wrap"
                            justifyContent="center"
                            sx={{ order: { xs: 1, sm: 2 } }}
                        >
                            <Link
                                href="/privacy"
                                sx={{
                                    color: 'text.secondary',
                                    textDecoration: 'none',
                                    fontSize: { xs: '0.8rem', md: '0.875rem' },
                                    '&:hover': { color: 'primary.main' }
                                }}
                            >
                                {translations.privacyPolicy}
                            </Link>
                            <Link
                                href="/terms"
                                sx={{
                                    color: 'text.secondary',
                                    textDecoration: 'none',
                                    fontSize: { xs: '0.8rem', md: '0.875rem' },
                                    '&:hover': { color: 'primary.main' }
                                }}
                            >
                                {translations.termsOfService}
                            </Link>
                            <Link
                                href="/returns"
                                sx={{
                                    color: 'text.secondary',
                                    textDecoration: 'none',
                                    fontSize: { xs: '0.8rem', md: '0.875rem' },
                                    '&:hover': { color: 'primary.main' }
                                }}
                            >
                                {translations.returnPolicy}
                            </Link>
                        </Box> */}
                    </Box>
                </Container>
            </Box>
        </ThemeProvider>
    );
};

export default AppFooter;